import { Navigate, Route, Routes } from "react-router-dom"
import { HomePage, EventPage, AboutUsPage, TermsAndConditionsPage, FaqPage } from "../../pages/public"



export const PublicRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/event/:id" element={<EventPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/termsandconditions" element={<TermsAndConditionsPage />} />

            <Route path="*" element={<Navigate to='/' />} />
        </Routes>
    )
}
